import { getReq } from './axios';
import { allReferenceParams } from './models';
var BASE_URL = "".concat(apiUrl, "/interests-and-fees-report-amounts");
export var getInterestsFeesReportAmounts = function getInterestsFeesReportAmounts(params) {
  return getReq(BASE_URL, {
    params: allReferenceParams(params)
  });
};